import authenticationLocationStorageService from '@/services/authentication-local-storage.service'
import { ITranscoHyperProxiRequest } from '@/api/types/requests/transco-hyper-proxi'

// tslint:disable-next-line no-var-requires
const defaults = require('superagent-defaults')
const superagent = defaults()
const request = {
  init: () => {
    return superagent.set(
      'Authorization', `Bearer ${authenticationLocationStorageService.token}`)
  },
  delete: (url: any) => request.init().delete(url),
  get: (url: any) => request.init().get(url),
  post: (url: any) => request.init().post(url),
  put: (url: any) => request.init().put(url),
  patch: (url: any) => request.init().patch(url),
}

export default request
